import {
	currentUserIsAdmin,
	legacyPermissionsEnabled,
} from '@netx/core-permissions-next/enablers';
import {shouldEnforceAlphabetical} from '@netx/core-category/utils/shouldEnforceAlphabetical';
import {
	categoryPermissionChecker,
	PermissionMatrixName,
	PermissionName,
} from '@netx/core-permissions-next/utils';
import {type ICategory} from '../schema';
import {currentUserMeetsUserLevel, UserLevel} from '@netx/core-user-next/utils';

export const canReorderCategoryChildren = (category?: ICategory): boolean => {
	if (shouldEnforceAlphabetical()) return false;

	if (legacyPermissionsEnabled()) {
		if (!category || category.id === 1)
			return currentUserMeetsUserLevel(UserLevel.MANAGER);
	} else if (!category || category.id === 1) return currentUserIsAdmin();

	return categoryPermissionChecker({
		category,
		permissionMatrixName: PermissionMatrixName.MODIFY,
		permissionName: PermissionName.REORDER_FOLDERS,
	});
};
